// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Notification from '../../../notification';

const AddReportIssue = ({
                            currentWorkOrder,
                            user,
                            createNewIssueReport,
                            setShowAddReportIssue,
                        }) => {
    const reportAnIssue = async (event) => {
        event.preventDefault();
        if (!event.target.description.value) {
            Notification('warning', { message: 'Add description to report!' });
        } else {
            const { _id, contractor_id: contractorId } = currentWorkOrder;
            const sendIssueReport = {
                work_order_id: _id,
                contractor_id: contractorId,
                client_issue_description: event.target.description.value,
                client_name: user.firstName + user.lastName,
            };
            const result = await createNewIssueReport(sendIssueReport);
            if (result) setShowAddReportIssue(false);
        }
    };

    return (
        <div className="line_blocks">
            <form className="new_note" onSubmit={reportAnIssue}>
                <div className="field_col">
                    <label className="field_name" htmlFor="description">Add new note</label>
                    <div className="field_block">
            <textarea
                id="description"
                name="description"
                maxLength="500"
                placeholder="Type here"
            />
                    </div>
                </div>
                <div className="profile_actions">
                    <button
                        type="button"
                        className="standard_btn dark_btn"
                        aria-label="cancel"
                        onClick={() => setShowAddReportIssue(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="standard_btn primary_btn"
                        aria-label="save and publish"
                    >
                        Save &amp; Report An Issue
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddReportIssue;
